<template>
  <el-dialog
    :title="$t('text.add_pod')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="400px"
    class="edit-group"
  >
    <div>
      <el-form
        label-width="120px"
        :model="form"
        ref="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item prop="MacAddress">
          <span slot="label">
            {{ $t('text.pod_serial_number') }}
            <el-tooltip placement="top">
              <img
                src="@/assets/image/how-to-find-device-info/pod-number.png"
                slot="content"
                class="w-200"
              />
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <SerialNumber
            @podSerialNumberChange="podSerialNumberChange"
            :value="form.MacAddress"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import SerialNumber from '@/components/manage/patients/SerialNumber.vue'
import { podSerialNumberPrefix } from '@/const'
export default {
  data() {
    let checkSerialNumber = (rule, value, callback) => {
      let serialNumberRule = /[A-F0-9]/
      if (value && (!serialNumberRule.test(value) || value.length !== 4)) {
        callback(new Error('Pod serial number format entered is incorrect.'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      loading: false,
      form: {
        MacAddress: ''
      },
      rules: {
        MacAddress: [
          {
            required: true,
            message: 'Pod serial number is required',
            trigger: 'blur'
          },
          { validator: checkSerialNumber, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    SerialNumber
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        MacAddress: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    podSerialNumberChange(data) {
      this.form.MacAddress = data
        .filter(item => {
          return !item.disabled
        })
        .map(item => {
          return item.character
        })
        .join('')
    },
    save() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.loading = true
      ApiService.SaveSitePod({
        MacAddress:
          podSerialNumberPrefix +
          this.form.MacAddress.substring(this.form.MacAddress.length - 4),
        SiteId: this.$store.getters[`user/selecteOrganisationId`]
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
            this.$parent.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
